import * as hf from './_hf';
import * as ht from './_ht';

export const getDmn = () => { // get domain
//  const _dmn = document.domain;
  const _dmn = location.host;
  return {
    all: _dmn,
    sub: String(_dmn).substring(0, _dmn.indexOf('.'))
  };
};

export const getPmrz = (key: ht.s) => { // get url parameters
  const _url = new URL(window.location.href);
  //hf.l(`cmWEB 14: ${document.readyState}, ${_url}`);
  return _url.searchParams.get(key); // moveTo のものを取得できないため、useNgnz の getPmrz を使用
};

export const cls = () => {
  window.close();
};